import { gql } from '@apollo/client'
import { BRAND_EXECUTION_FRAGMENT } from '../fragments/BrandExecutionFragment'

export const BRAND_EXECUTION_FOR_ZONE_PATH = gql`
  query BrandExectionForZonePath($input: DXOExecutionForZonePathInput!) {
    brandExecutionForZonePath(input: $input) {
      hasMore
      count
      isLeafNode
      results {
        ...BrandExecution
      }
    }
  }
  ${BRAND_EXECUTION_FRAGMENT}
`
